import { Constants } from '../data';
import { curriculumManager } from '../data/CurriculumManager';

const initialState = {
  currentContentSet: [],
  currentContent: {},
  // Current question index within a round/level
  questionNumber: 0,
  // number of questions the player has gotten correct this round
  questionsCorrect: 0,
  // number of questions answered this round
  questionsAnswered: 0,
  currentProgress: 0,
  currentContentSides: [],
  isG35Level: false,
};

const roundReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'CLEAR_ROUND':
      return {
        ...initialState,
        currentContentSides: state.currentContentSides,
      };

    case 'INIT_LEVEL': {
      const { level } = action.payload; // 1-indexed
      const levelIndex = level - 1; // 0-indexed
      const newContentSides = [...state.currentContentSides];
      if (newContentSides[levelIndex] === undefined) {
        newContentSides[levelIndex] = 1;
      }
      newContentSides[levelIndex] = newContentSides[levelIndex] === 0 ? 1 : 0;
      return {
        ...initialState,
        isG35Level: level >= Constants.MIN_G35_LEVEL,
        currentContentSet: curriculumManager.loadRoundContent(level, newContentSides[levelIndex]),
        currentContent: null,
        currentContentSides: newContentSides,
      };
    }
    case 'INCREMENT_QUESTIONS_CORRECT':
      return {
        ...state,
        questionsCorrect: state.questionsCorrect + 1,
      };
    case 'INCREMENT_QUESTIONS_ANSWERED':
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
      };
    case 'LOAD_NEW_QUESTION': {
      // Update progress bar to reflect that user has completed all previous questions up to this current one
      const progress = ((state.questionNumber) / state.currentContentSet.length) * 100;
      return {
        ...state,
        questionNumber: state.questionNumber + 1,
        currentContent: state.currentContentSet[state.questionNumber],
        currentProgress: parseFloat(progress.toFixed(5)),
      };
    }
    case 'COMPLETE_PROGRESS_BAR': {
      return {
        ...state,
        currentProgress: 100,
      };
    }
    case 'INIT_ONBOARDING':
      return {
        ...state,
        currentContent: curriculumManager.loadOnboardingContent()[0],
      };
    case 'CHANGE_CURRENT_LEVEL':
      return {
        ...state,
        isG35Level: action.payload.level >= Constants.MIN_G35_LEVEL,
      };
    default:
      return state;
  }
};

export default roundReducer;
